import { render, staticRenderFns } from "./DataViewSharingPopup.vue?vue&type=template&id=acb9400e&"
import script from "./DataViewSharingPopup.vue?vue&type=script&lang=js&"
export * from "./DataViewSharingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports